<template>
  <v-app>
      <v-main id="main">
        <Nav></Nav>
        <transition :name="transitionName" :enter-class="enterCls" :enter-active-class="enterActiveCls" :leave-class="leaveCls" :leave-active-class="leaveActiveCls">
          <router-view></router-view>
        </transition>
      </v-main>
  </v-app>
</template>

<script>
import Nav from '@/components/Common/Nav'
export default {
  name: 'App',
  components: {
    Nav
  },
  watch: {
    '$route' (to, from) {
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    }
  },
  computed: {
    enterCls () {
      return this.transitionName + '-enter'
    },
    enterActiveCls () {
      return this.transitionName + '-enter-active'
    },
    leaveCls () {
      return this.transitionName + '-leave'
    },
    leaveActiveCls () {
      return this.transitionName + '-leave-active'
    }
  },
  mounted () {
    const currentUrl = window.location.href
    localStorage.setItem('loginandredirect', currentUrl)
    localStorage.setItem('portaltype', '')
    localStorage.setItem('privateportal', 'yuncai')
  },
  updated () {
    window.scroll(0, 0)
  },
  data: () => ({
    transitionName: 'fade'
  })
}
</script>
<style lang="scss">
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  transition: all .3s;
  position: absolute;
  width: 100%;
  left: 0;
  .v-footer {
    visibility: hidden;
  }
}
.slide-right-enter {
  transform: translateX(-100%);
}
.slide-right-leave-active {
  transform: translateX(100%);
}
.slide-left-enter {
  transform: translateX(100%);
}
.slide-left-leave-active {
  transform: translateX(-100%);
}
.fade-enter-active, .fade-leave-active {
  opacity: 1;
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.v-toolbar__content, .v-toolbar__extension {
  padding: 0 !important;
}
th,td {
  border-bottom: 0!important;
}

.qr-code {
  .v-image:hover {
    overflow: unset;
    z-index: 1;
    .v-image__image {
      position: absolute;
      width: 200%;
      height: 200%;
      left: -50%;
      top: -50%;
    }
  }
  span {
    font-size: 14px;
  }
}
.v-data-table--dense > .v-data-table__wrapper > table > {
  tbody,
  thead,
  tfoot{
     > tr > td {
      padding-top: 3px!important;
      padding-bottom: 3px!important;
    }
  }
}
.v-banner__text .content {
  z-index: 1000;
  position: relative;
  background-color: transparent;
}
.v-banner .container > .row {
  > .col > .row > .col {
    > * {
      position: relative;
      z-index: 2;
    }
  }
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #3f3f3f3b;
  }
}
.v-toolbar.v-toolbar {
  transition: all .2s;
}
.v-app-bar__nav-icon {
  &.v-btn--icon.v-size--default .v-icon, .v-btn--fab.v-size--default .v-icon {
    font-size: 36px;
  }
}
.v-main__wrap {
  display: flex;
  flex-direction: column;
}
.card.data-base {
  .icon {
    .v-image__image {
      background-size: 100%;
    }
    .v-responsive__content {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.page {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  // background-color: #fff!important;
  &:not(.home) {
    padding-top: 96px;
  }
  .row {
    margin-left: 0;
    margin-right: 0;
  }
  .page-content {
    flex: 1 0 auto;
  }
}
.v-menu__content {
  margin-top: 40px;
}
.html-content {
  overflow-x: auto;
  img {
    max-width: 100%;
  }
  .title {
    margin-bottom: 30px;
    text-align: center;
    a {
      font-size: 14px;
      float: right;
    }
  }
  table {
    width: 100%;
  }
  tbody {
    > tr:first-child {
      background-color: #e8e8e8
    }
    td {
      padding-left: 5px;
    }
  }
}
.company {
  .img-wrapper {
    .v-responsive__content {
      width: 20%!important;
      @media (max-width: 480px) {
        width: 33.33333333%!important;
      }
    }
  }
}
.page-input {
  &.v-input--dense > {
    .v-input__control {
      .v-input__slot {
        min-height: 28px!important;
        max-height: 28px!important;
        margin-bottom: 0;
      }
      .v-text-field__details {
        display: none;
      }
    }
  }
}
.tabs-items {
  .list {
    min-height: 420px
  }
}
</style>
